import CJBonusReceivedPlayersSection from './CJBonusReceivedPlayersSection';

export default CJBonusReceivedPlayersSection;
